import { React, useState, useEffect } from 'react'
import styles from './LineChart.module.scss'
import Select from 'react-select'
import Highcharts, { chart } from 'highcharts'
import Spinner from '../../../components/Loader/Spinner'
import { components } from 'react-select'
import { Checkbox, FormField } from '@better-ui/react'
import Chart from '../../../components/Highcharts/Chart'
import getLineChartOptions from '../../../components/LineAreaChart/areaChartOptions'
import moment from 'moment'
import TrendsCount from './TrendsCount'
import { useGeoState } from '../../../components/GeoProvider'
import getVectorImage from '../../../utils/getVectorImage'
import dayjs from 'dayjs'
const AllergyAqiLineChartCompare = ({chartData,dataCategory }) => { 
    const {
    getAllergyFilterState,
    setAllergyFilterState,
  } = useGeoState()
  
  const [selectedOptions, setSelectedOptions] = useState([])
  const [selectSeasonComma, setSelectSeasonComma] = useState('')

  useEffect(() => {
    setSelectedOptions([dataCategory[0]])
    setSelectSeasonComma(dataCategory[0].label)
  }, [dataCategory])

let season_arr=selectSeasonComma.split(',')

let fromdate=''
let todate=''
let load_date=''
if(chartData.length>0)
  {
    let json_value=(chartData[0].json_value)
    if(json_value!==null)
      {
        fromdate=moment(json_value[0][0]).format('MMM DD, YYYY')
        todate=moment(json_value[json_value.length-1][0]).format('MMM DD, YYYY')
        load_date= dayjs().day(+1).format('MMM DD, YYYY')
      }

  }

let chartColors=['#15A796','#C72887','#8061BC','#E4780C','#1E82CB']

let linecharttest=[]
function getSeasonData(chartData){
    let seasonarr=[]
   for(let j=0;j<season_arr.length;j++)
   {
    for(let i=0;i<chartData.length;i++)
    {
       
        if(chartData[i].season===season_arr[j])
        {
        let chartJson=(chartData[i].json_value)
        const dd=chartJson.map((chartval)=>{
          return([moment(chartval[0]).format('YYYY-MM-DD'), chartval[1]])
        })
        let startPoint=0
        if(getAllergyFilterState===1 && dd.length>10)
          {
            startPoint=dd.length-10
          }
        else if(getAllergyFilterState===2 && dd.length>24)
          {
            startPoint=dd.length-24
          }
        else if(getAllergyFilterState===3 && dd.length>=52) {
          startPoint=dd.length-52
        }
        for(var s=startPoint;s<dd.length;s++)
        {
            seasonarr.push([new Date(chartJson[s][0]).getTime(), chartJson[s][1]<=-1?0:chartJson[s][1]])
        }
        let obj1={
            name: chartData[i].season,
            data:seasonarr,
            dashStyle: 'solid',
            color: chartColors[i],
            visible: true,
            showInLegend: true,
          }
          seasonarr=[]
          linecharttest.push(obj1)
        } 
    }
    }
    return []
}  
    const lineChartData = [
        
        {
          name: 'Mild Asthma',
          data:getSeasonData(chartData),
          dashStyle: 'solid',
          color: Highcharts.getOptions().colors[9],
          visible: true,
          showInLegend: true,
        },
      ]
      const lineOptions = getLineChartOptions(
        linecharttest,
        '',  
      )
       //// Start here
  const Option = (props) => {  
    const text =
      'Select up to 5 to compare.'
    let disabled = false
    if (selectedOptions.length >= 5 && !props.isSelected) {
      disabled = true
    }
    return (
      <div>
        {props.label === dataCategory[0].label? (
          <div
            style={{ padding: '10px 10px', color: '#4B4D4F', fontSize: '14px' }}
          >
            {text}
          </div>
        ) : (
          ''
        )}

        <components.Option {...props}>
          <FormField disabled={disabled}>
            <Checkbox checked={props.isSelected}> {props.label}</Checkbox>
          </FormField>
        </components.Option>
      </div>
    )
  }
  ////End here

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: 'white',
      borderRadius: '4px',
      border: '1px solid #4B4D4F',
      boxSizing: 'border-box',
      cursor: 'pointer',
    }),
    option: (base, state) => ({
      ...base,
      color: '#1e2022',
      backgroundColor: 'white',
      padding: '.5rem 3rem .5rem .5rem',
      cursor: 'pointer',
      fontWeight: state.isSelected ? 'bold' : '',
    }),
    multiValue: (styles, { data }) => {
      return {
        ...styles,
        backgroundColor: '#002677',
        color: 'white',
        borderRadius: '100px',
        cursor: 'pointer',
        padding: '0px 0px 0px 5px',
      }
    },
    multiValueLabel: (styles, { data }) => ({
      ...styles,
      color: 'white',
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1
      const transition = 'opacity 300ms'

      return { ...provided, opacity, transition }
    },
    multiValueRemove: (styles, { data }) => ({
      ...styles,
      color: 'white',
      backgroundColor: '#002677',
      borderRadius: '100px',
      width: '32px',

      '&:hover': {
        backgroundColor: '#002677',
        color: 'white',
        borderRadius: '100px',
      },
    }),
  }
  
  function tabsChangeHandlerNew(e) {
    if (e.length <= 5) {
      setSelectedOptions(e)
     let valu=''
      e.map((dd)=>{
        if(valu==='')
        {
          valu+=dd.label
        }
        else
        {
          valu+=","+dd.label
        }
      })
      setSelectSeasonComma(valu)
    }
  }
  const handlefilterState = (index) => {
     setAllergyFilterState(index)
  }
  return (
    <div className={styles.base}>
      <div className={styles.maindivFormat}>
        <div  style={{ display: 'flex' }}>
          <div style={{ width: '100%' }}>
            <span className={styles.captionFormat}>Allergy & Air Quality Condition Trends</span>
          </div>
          <div
            style={{
              minWidth: '20%',
              maxWidth: '40%',
              margin:'1px 1.5% 0px 40%',
              borderRadius: '4px',
              boxSizing: 'border-box',
              width: '100%',
              cursor: 'pointer',
            }}
          >
            <Select
              isMulti
              options={dataCategory}
              onChange={tabsChangeHandlerNew}
              value={selectedOptions}
              placeholder={`Compare`}
              styles={colourStyles}
              components={{
                Option,
              }}
              hideSelectedOptions={false}
              closeMenuOnSelect={false}
            />
          </div>
        </div>
      </div>
      <div style={{display:'flex'}}>
      <div className={styles.filterDiv}>
              <div style={{fontSize:'16px',padding:'5px'}}>Zoom</div>
              <div onClick={(event) => handlefilterState(1)} className={getAllergyFilterState===1?styles.activeWeekDiv:styles.weekDiv}>10w</div>
              <div onClick={(event) => handlefilterState(2)} className={getAllergyFilterState===2?styles.activeWeekDiv:styles.weekDiv}>24w</div>
              <div onClick={(event) => handlefilterState(3)} className={getAllergyFilterState===3?styles.activeWeekDiv:styles.weekDiv}>52w</div>
       </div>
       <div className={fromdate!==''?styles.dateDiv:styles.hideDateDiv}>
            <span>{fromdate}</span>{getVectorImage('arrowforward','16px', '12px')}<span>{todate}</span> Updated for <span>{load_date}</span>
            </div>
        </div>
       <div id="allergy" className={styles.maindivFormat} style={{overflowY:'hidden',overflowX:getAllergyFilterState===1?'hidden':'scroll'}} >
        <div style={{display:getAllergyFilterState===1?'block':'none'}}>
          {lineOptions ? (
            <>
            <Chart
            chartOptions={lineOptions}
            height={'360px'}
            width={'100%'}
          />
          <TrendsCount data={lineOptions} filter={getAllergyFilterState}/>
          </>
          ) : (
            <Spinner />
          )}
        </div>
        <div  style={{display:getAllergyFilterState===2?'block':'none'}}>
          {lineOptions ? (
            <>
            <Chart
            chartOptions={lineOptions}
            height={'360px'}
            width={'200%'}
          />
          <TrendsCount data={lineOptions} filter={getAllergyFilterState}/>
          </>
          ) : (
            <Spinner />
          )}
        </div>
       
        <div  style={{display:getAllergyFilterState===3?'block':'none'}}>
          {lineOptions ? (
             <>
            <Chart
            chartOptions={lineOptions}
            height={'360px'}
            width={'420%'}
          />
          <TrendsCount data={lineOptions} filter={getAllergyFilterState}/>
          </>
          ) : (
            <Spinner />
          )}
        </div>
       
       
      </div>
      </div>
  )
}

export default AllergyAqiLineChartCompare
